import React, { useContext } from "react";
import {
  IonAccordionGroup,
  IonAccordion,
  IonItem,
  IonLabel,
} from "@ionic/react";
import moment from "moment";
import { formatMonto } from "../../utils";
import { ConceptosContext } from "../../context/ConceptosContext";
import EmptyState from "../common/EmptyState";

const EstimacionesConcepto = () => {
  const { concepto } = useContext(ConceptosContext);

  const renderEstimaciones = () => {
    const { estimaciones } = concepto;
    if (!Array.isArray(estimaciones) || estimaciones.length === 0) {
      return (
        <EmptyState
          icon="fa fa-file-invoice-dollar"
          message="Este concepto aún no aparece en ninguna estimación."
        />
      );
    }
    return estimaciones.map((estimacion, index) => (
        <IonAccordion key={estimacion.numero} value={estimacion.idEstimacion}>
          <IonItem slot="header" color="light">
            <IonLabel>
              Estimación #{estimacion.numero} -{" "}
              {moment(estimacion.fecha_inicio).format("DD MMM YYYY")}
            </IonLabel>
          </IonItem>
          <div slot="content" className="container-fluid py-2">
            <div className="row align-items-center border">
              <div className="col bold bg-light py-2">Anterior</div>
              <div className="col">{formatMonto(estimaciones[index - 1]?.autorizado || estimaciones[index - 1]?.estimado || 0)}</div>
            </div>
            <div className="row align-items-center border">
              <div className="col bold bg-light py-2">Estimado</div>
              <div className="col">{formatMonto(estimacion.estimado)}</div>
            </div>
            <div className="row align-items-center border">
              <div className="col bold bg-light py-2">Supervisado</div>
              <div className="col">{formatMonto(estimacion.supervisado)}</div>
            </div>
            <div className="row align-items-center border">
              <div className="col bold bg-light py-2">Autorizado</div>
              <div className="col">{formatMonto(estimacion.autorizado)}</div>
            </div>
            <div className="row align-items-center border">
              <div className="col bold bg-light py-2">Importe</div>
              <div className="col">${formatMonto(estimacion.importe_autorizado)}</div>
            </div>
          </div>
        </IonAccordion>
      ));
  };

  return (
    <div>
      <h3 className="h5">Estimaciones</h3>
      <IonAccordionGroup>{renderEstimaciones()}</IonAccordionGroup>
    </div>
  );
};

export default EstimacionesConcepto;
